module.exports = __webpack_public_path__ + "static/media/ic_template_6.b98fc0b7.png";